import { withViewData } from "../App/ViewData"
import { FocusDataView } from "./Focus/DataView"
import { FocusViewUI } from "./Focus/FocusViewUI"
import { FocusViewProps } from "./Focus/Params"

// FocusView is the app's live "current log" entry surface and the create/live exemplar
// for the centralized Data-layer (issue #1187). `FocusDataView` is the store /
// `useDeps` data-acquisition layer: it builds the `FocusDataViewData` and provides it
// via `FocusDataContext`, routing writes through `DataStore.mutate`, so the
// presentational `FocusViewUI` never touches acquisition. `FocusViewProps` has no
// `children` slot, so `withViewData` injects `FocusViewUI` into the acquisition
// component's child slot directly (unlike DayView, which renames its `children`).
export const FocusView = withViewData<FocusViewProps>({
  acquire: FocusDataView,
  ui: FocusViewUI,
});

// Re-export the shared public API so existing `from "./FocusView"` imports keep working.
// FocusViewConfirmationDialog is the previous name of FocusConfirmationDialogView, kept
// as an alias for backward compatibility.
export { FocusViewConfirmationType, FocusViewData } from "./Focus/Context"
export type { FocusViewState, SubscriptionWarningKey } from "./Focus/Context"
export type { FocusViewProps } from "./Focus/Params"
export { FocusConfirmationDialogView, FocusConfirmationDialogView as FocusViewConfirmationDialog, FocusViewConfirmationDialogData } from "./Focus/ConfirmationDialogView"
